import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ClipboardListIcon } from 'lucide-react';
import { useQuoteModal } from '../contexts/QuoteModalContext';

/**
 * Floating quote button. It also invites the visitor once, automatically,
 * after they have read enough of the page to be interested.
 */
export function QuoteLauncher() {
  const {
    isOpen,
    openQuote,
    hasBeenOpened
  } = useQuoteModal();
  const [visible, setVisible] = useState(false);
  const [invited, setInvited] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY;
      setVisible(scrolled > 420);
      const progress = scrolled / Math.max(document.body.scrollHeight - window.innerHeight, 1);
      if (!invited && !hasBeenOpened && progress > 0.35) {
        setInvited(true);
        openQuote();
      }
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, [invited, hasBeenOpened, openQuote]);
  return <AnimatePresence data-id="element-278" data-mp="3try5hjjb953h">
      {visible && !isOpen && <motion.button type="button" onClick={openQuote} initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.98
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-5 right-5 z-40 flex items-center gap-2.5 rounded-full bg-ember-500 px-5 py-3.5 font-display text-base uppercase tracking-wide text-ink-900 shadow-xl transition-colors duration-150 ease-out hover:bg-ember-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-forest-800 sm:px-6 sm:text-lg" data-id="element-279" data-mp="2mok6569hf07">
          <ClipboardListIcon className="h-5 w-5" aria-hidden="true" data-id="element-280" data-mp="3623pit3p30f0" />
          Get a free quote
        </motion.button>}
    </AnimatePresence>;
}